import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { data } from './data.js';

function SearchBar()
{
  const [contacts, setContacts] = useState(data);
  const [search, setSearch] = useState('');
  return (
    <div>
      <Container>
        <h1 className='text-center mt-4'>QUESTION PAPER AVAILABLE</h1>
        <Form>
          <InputGroup className='my-3'>

            {/* onChange for search */}
            <Form.Control
              onChange={(e) => setSearch(e.target.value)}
              placeholder='Search'
            /> <a href='https://youai.ai/ais/1af41d3f-b6fa-404b-840c-4d0f7b7f5a6c'><i class="fa-solid fa-robot fa-lg" style={{top:"49%",left:"101%",position:"absolute",cursor:"pointer" }}></i></a>
          </InputGroup>
        </Form>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>URL</th>
            </tr>
          </thead>
          <tbody>
            {data
              .filter((item) => {
                return search.toLowerCase() === ''
                  ? item
                  : item.name.toLowerCase().includes(search);
              })
              .map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td style={{cursor:"pointer"}}><a href={item.url}>{item.url}</a></td>
                  <td>{item.discord}</td>

                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
}

export default SearchBar;